function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.767613 29.6188H45.2275V1.14385H0.767613V29.6188ZM45.4976 29.8813H0.497559V0.881348H45.5066L45.4976 29.8813Z",
  fill: "#29ED87"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0103 12.8364H14.2885V16.4714H16.7325V17.4947H13.0103V12.8364Z",
  fill: "#29ED87"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2166 16.5515H19.7162C20.4093 16.5515 20.6659 16.2801 20.6659 15.5415V14.7807C20.6659 14.0421 20.4093 13.7752 19.7162 13.7752H19.2166C18.5234 13.7752 18.2669 14.0421 18.2669 14.7807V15.5638C18.2669 16.3023 18.5234 16.5737 19.2166 16.5737V16.5515ZM19.6667 17.5793H19.2436C17.6773 17.5793 16.9121 16.7517 16.9121 15.5104V14.843C16.9121 13.6017 17.6773 12.7741 19.2436 12.7741H19.6667C21.2375 12.7741 21.9981 13.6017 21.9981 14.843V15.4881C21.9981 16.7295 21.2375 17.557 19.6667 17.557",
  fill: "#29ED87"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.332 13.8597H24.897C24.1003 13.8597 23.8663 14.14 23.8663 14.8385V15.5637C23.8663 16.3023 24.1228 16.5737 24.816 16.5737H25.5946C26.0762 16.5737 26.2698 16.4447 26.2698 16.1288V15.7195H24.9735V14.7317H27.422V16.2044C27.422 17.1343 26.7604 17.5392 25.5496 17.5392H24.852C23.2812 17.5392 22.5205 16.7784 22.5205 15.4703V14.8252C22.5205 13.615 23.3037 12.8364 24.834 12.8364H27.332V13.8597Z",
  fill: "#29ED87"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2888 16.5515H30.7884C31.4816 16.5515 31.7381 16.2801 31.7381 15.5415V14.7807C31.7381 14.0421 31.4816 13.7752 30.7884 13.7752H30.2888C29.5957 13.7752 29.3436 14.0421 29.3436 14.7807V15.5638C29.3436 16.3023 29.5957 16.5737 30.2888 16.5737V16.5515ZM30.7389 17.5793H30.3158C28.745 17.5793 27.9844 16.7517 27.9844 15.5104V14.843C27.9844 13.6017 28.745 12.7741 30.3158 12.7741H30.7389C32.3052 12.7741 33.0704 13.6017 33.0704 14.843V15.4881C33.0704 16.7295 32.3052 17.557 30.7389 17.557",
  fill: "#29ED87"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.79903 20.9296H39.39V9.63299H6.79903V20.9296ZM39.6556 21.1921H6.54248V9.37048H39.6556V21.1921Z",
  fill: "#29ED87"
});
function SvgBenefit12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit12);
export default __webpack_public_path__ + "static/media/benefit_12.71ce965b4050c7922b6166448f5ab6ad.svg";
export { ForwardRef as ReactComponent };